import 'jquery';
import * as utils from './utils';

export class Tab {
    constructor(selector, json) {
        this.json = json;
        this.selector = selector;
    }

    init() {
        var html = this.html();
        if (html !== null) {
            $(this.selector).append(html);
        }
    }

    html() {
        if (typeof this.json === "undefined" || this.json === null || this.json.length === 0) {
            return null;
        }
        // create tabs
        var html = '<ul class="nav nav-pills unify-tab">';
        var tabPanes = '<div class="tab-content">';
        for (var i = 0, nr = this.json.length; i < nr; i++) {
            var item = this.json[i];
            var tabId = typeof item.Id !== "undefined" ? item.Id : utils.getUniqueComponentId({ prefix: 'tab-' });

            // create tab
            var activeHtml = typeof item.IsActive !== "undefined" && item.IsActive === true ? ' active' : '';
            var disabledHtml = typeof item.IsDisabled !== "undefined" && item.IsDisabled === true ? ' disabled' : '';
            var renderPane = typeof item.RenderPane !== "undefined" && item.RenderPane === false ? false : true;
            var linkLogic;
            if (typeof item.Uri !== "undefined") {
                // not a tab
                linkLogic = ' href="' + item.Uri + '"';

            } else {
                // a tab, add jquery logic for tab
                linkLogic = ' data-toggle="tab" href="#' + tabId + '" role="tab"';
            }
            // we set active Html on both li and a initially, in Bootstrap3 the active will be set on li (in Bootstrap4 on a)
            // We have styled both to make transition to bootstrap 4 smooth but you have to replace bootstrap3 scss with bootstrap4 scss.
            html += '<li class="nav-item' + activeHtml + '">' +
                '<a class="nav-link' + activeHtml + disabledHtml + '"' + linkLogic + '>' + item.Title + '</a>' +
                '</li>';

            // create pane
            if (renderPane) {
                tabPanes += '<div class="tab-pane' + activeHtml + '" id="' + tabId + '" role="tabpanel">' + item.Content + '</div>';
            }
        }
        tabPanes += '</div>';
        html += '</ul>';
        return html + tabPanes;
    }
}
